import { ApiService } from "@/api/services/ApiService";
import { ApiEndpoints } from "@/constants/ApiEndpoints";
import { TokenRequiredStrategy } from "@/api/strategies/TokenRequiredStrategy";
import { Section } from "@/interfaces/SpinTheWheel/Section";
import { WheelInitialData } from "@/interfaces/SpinTheWheel/WheelInitialData";

const mapSectionTypeToText = (type: string, value: number): string => {
    switch (type) {
        case 'win_nothing':
            return 'Try Again!';
        case 'fixed_coins':
            return `${value} Coins!`;
        case 'fixed_percentage':
            return `${value}% Bonus!`;
        case 'time_gated_percentage':
            return `${value}% Boost!`;
        default:
            return 'Mystery Prize!';
    }
};

class SpinTheWheelClass extends ApiService {
    constructor() {
        super(TokenRequiredStrategy);
    }

    SPIN_THE_WHEEL_ENDPOINT = ApiEndpoints.SPIN_THE_WHEEL;

    async getWheelInitialData() {
        const response = await this.get(this.SPIN_THE_WHEEL_ENDPOINT);
        const data: WheelInitialData = response.data;
        return {
            ...data,
            wheel_data: data.wheel_data.map((section: Section) => ({
                ...section,
                text: mapSectionTypeToText(section.type, section.value)
            }))
        };
    }

    async getActiveWheelRewards() {
        const response = await this.get('/user/wheel_reward');
        const data = response.data;
        return data.map((reward: Section) => ({
            ...reward,
            text: mapSectionTypeToText(reward.type, reward.value)
        }));
    }

    async getResult() {
        const response = await this.post(this.SPIN_THE_WHEEL_ENDPOINT);
        const data = response.data;
        return {
            ...data,
            text: mapSectionTypeToText(data.type, data.value)
        };
    }
}

const SpinTheWheelService = new SpinTheWheelClass();

export { SpinTheWheelService };